import client from '@/support/Client';
export class Branding {
    static fetch() {
        return client('get', '/branding', {}).then((response) => {
            const data = response.data.data || response.data;
            return Object.assign(new Branding(), data);
        });
    }
    static apply(branding) {
        if (branding.color_primary) {
            document.documentElement.style.setProperty('--brand-primary', branding.color_primary);
            if (window.App && window.App.$vuetify) {
                window.App.$vuetify.theme.primary = branding.color_primary;
            }
        }
        if (branding.color_secondary) {
            document.documentElement.style.setProperty('--brand-secondary', branding.color_secondary);
            if (window.App && window.App.$vuetify) {
                window.App.$vuetify.theme.secondary = branding.color_secondary;
            }
        }
    }
}
